import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TableHeader, TableRow } from "../../../components";
import Button from "../../../components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import IntegrateConfigure from "./IntegrateConfigure";
import { getPssData, getToolBarPss } from "../../../redux/slices/CurrentUserSlice";
import IntegrateToolbar from "./IntegrateToolbar";

export interface PssAuthResponse {
  authKey?: string;
  officeId: string;
  officePss?: boolean;
  toolbarPss?: boolean;
  // add other properties if needed
}

const PssTab = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentUser } = useSelector((state: RootState) => state.currentUser);
  const { currentOffice } = useSelector((state: RootState) => state.office);
  const [show, setShow] = useState(false);
  const [showToolbar, setShowToolBar] = useState(false);
  const [pssData, setPssData] = useState<PssAuthResponse | null>();
  const [pssToolbarData, setPssToolbarData] = useState<PssAuthResponse | null>();

  const headers = [
    {
      title: "Setup",
      extraClasses: "w-full",
      sortKey: "",
      isClickable: false,
    },
    {
      title: "Configuration",
      extraClasses: "w-full",
      sortKey: "",
      isClickable: false,
    },
  ];

  const getData = async () => {
    const validId = currentUser?.userType === "system-admin" ? currentOffice?.officeId : currentUser?.offices && currentUser?.offices[0]?.officeId;
    const res = await dispatch(getPssData({ officeId: validId as string }));
    const res2 = await dispatch(getToolBarPss({ officeId: validId as string }));
    const pssResponse = res.payload as PssAuthResponse | null;
    const ToolbarResponse = res2.payload as PssAuthResponse | null;

    setPssData(pssResponse);
    setPssToolbarData(ToolbarResponse);
  };
  useEffect(() => {
    if ((currentUser?.offices && currentUser.offices.length > 0) || currentOffice?.officeId) {
      getData();
    }
  }, [currentUser, currentOffice]);
  const tableData = [
    {
      setup: "PSS Custom Form",
      configuration: (
        // <Button text="Configure" onClick={() => navigate(`/offices/${currentOffice?.officeId}/integrate-configure`)} variant="Primary" width="fit" />
        <Button
          text={pssData?.officePss ? "Configure" : "Coming Soon"}
          disabled={!pssData?.officePss}
          onClick={() => setShow(true)}
          variant="Primary"
          width="fit"
        />
      ),
    },
    {
      setup: "PSS Toolbar",
      configuration: (
        <Button
          // text={pssData?.toolbarPss ? "Configure" : "Coming Soon"}
          text="Configure"
          // disabled={!pssData?.toolbarPss}
          onClick={() => setShowToolBar(true)}
          variant="Primary"
          width="fit"
        />
      ),
    },
  ];

  return (
    <div className="w-full relative">
      {show ? (
        <IntegrateConfigure onBack={() => setShow(false)} />
      ) : showToolbar ? (
        <IntegrateToolbar onBack={() => setShowToolBar(false)} />
      ) : (
        <div>
          <div className="flex justify-between items-center border-b border-docnote-blue-light border-opacity-50">
            {headers.map((head, index) => (
              <TableHeader
                title={head.title}
                index={index}
                key={index}
                sortIcon={null}
                handleSort={() => null}
                extraClassesHeader={head.extraClasses}
                isClickable={head.isClickable}
              />
            ))}
          </div>
          {tableData.map((rowData, index) => {
            const sortedData = {
              setup: rowData.setup,
              configuration: rowData.configuration,
            };
            return (
              <TableRow
                data={Object.values(sortedData)}
                key={index}
                id={`pss-${index}`}
                tooltipVisible={false}
                extraClassesRow={headers.map(head => head.extraClasses)}
                handleOpenTooltip={() => null}
                handleCloseTooltip={() => null}
                tooltipOptions={[]}
                onRowClick={() => null}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PssTab;
